import { render, staticRenderFns } from "./LanguagesForm.vue?vue&type=template&id=88b9ab5c"
import script from "./LanguagesForm.vue?vue&type=script&lang=js"
export * from "./LanguagesForm.vue?vue&type=script&lang=js"
import style0 from "./LanguagesForm.vue?vue&type=style&index=0&id=88b9ab5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports